export default {
    employeeAdd: {
        method: 'POST',
        url: '/manage-system/employee',
        name: '新增员工',
    },
    employeeUpdate: {
        method: 'PUT',
        url: '/manage-system/employee',
        name: '更新员工',
    },
    employeePage: {
        method: 'POST',
        url: '/manage-system/employee/page',
        name: '分页查询员工',
    },
    employeeList: {
        method: 'POST',
        url: '/manage-system/employee/list',
        name: '不分页查询员工',
    },
    employeeDetail: {
        method: 'GET',
        url: '/manage-system/employee/{id}',
        name: '获取员工详情',
    },
    employeeDelete: {
        method: 'DELETE',
        url: '/manage-system/employee/{id}',
        name: '删除员工',
    },
    employeeGroupGet: {
        method: 'GET',
        url: '/manage-system/employee/group',
        name: '获取当前分组',
    },
    employeeGroupUpdate: {
        method: 'PUT',
        url: '/manage-system/employee/group',
        name: '更新当前分组',
    },
}
